<template>
<section class="pt-8 pt-md-5 pb-8 pb-md-14">
    <div class="container">
        <Spinner v-if="!loaded" />
        <div class="row" v-else>
            <div class="col-12">
                <h1 class="mb-0 fw-bold">Affiliate program</h1>
                <p class="mb-6 text-muted">
                    Read the terms of our affiliate program <a href="/help/affiliate">here</a><br>
                </p>
                <div class="row mb-5">
                    <div class="col">
                        <h4 class="mb-0">
                            Affiliate balance for all time
                            <small class="text-gray-700">{{ $state.context.currency_symbol }}</small>{{ $state.context.affiliate_amount }}
                        </h4>
                        <small class="text-gray-700">Available {{ $state.context.currency_symbol }}{{ $state.context.available_affiliate_amount }} (minus API costs)</small>
                    </div>
                    <div class="col-auto">
                        <router-link :to="{path: '/affiliate/order'}" class="btn btn-xl btn-primary">
                            Order payout
                        </router-link>
                    </div>
                </div>
                <div class="table-responsive">
                    <vue-good-table
                        :columns="columns"
                        :rows="rows"
                        :pagination-options="paginationOptions"
                        @page-change="onPageChange"
                    >
                        <template #table-row="props">
                            <span v-if="props.column.field === 'link'">
                                <a :href="props.row.link" target="_blank">{{ props.row.linkName }}</a>
                                <button class="btn-copy-inline" @click="copyLink(props.row.link)" title="Copy">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                                        <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"/>
                                        <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"/>
                                    </svg>
                                </button>
                            </span>
                            <span v-else-if="props.column.field === 'actions'">
                                <button class="btn btn-primary mb-1 me-1 btn-xs" @click="edit(props.row)">Edit</button>
                                <button class="btn btn-danger mb-1 btn-xs" @click="remove(props.row)">Delete</button>
                            </span>
                            <span v-else>
                                {{ props.formattedRow[props.column.field] }}
                            </span>
                        </template>
                    </vue-good-table>
                </div>
                <button class="btn btn-primary mb-1 btn-xs mt-3" @click="create" :disabled="disabled">Create a promocode</button>
            </div>
        </div>
    </div>
</section>
</template>

<script>
import { toDateTime } from "utils/date";
import Spinner from "../Spinner.vue"
import tablePagination from "../../mixins/tablePagination"

export default {
    components: {
        Spinner,
    },
    mixins: [tablePagination],
    data() {
        return {
            disabled: false,
            loaded: false,
            columns: [
                { label: "Name", field: "name", sortable: false },
                { label: "Code", field: "code", sortable: false },
                { label: "Invite Link", field: "link", sortable: false },
                { label: "Invited", field: "invited", sortable: false },
                { label: "Date of creation", field: "created_at", formatFn: toDateTime, sortable: false },
                { label: "Actions", field: "actions", sortable: false },
            ],
            rows: [],
        }
    },
    methods: {
        fetch(data) {
            data = data || {}
            data.per_page = 100
            this.$services.PromoCode().get(data).then(resp => {
                const rows = resp.body.data || [];
                rows.forEach((r) => {
                    const l = window.location;
                    r.link = `${l.protocol}//${l.host}/p/${r.code}`;
                    r.linkName = `${l.hostname}/p/${r.code}`;
                });
                this.rows = rows;
            }).finally(() => {
                this.loaded = true
            })
        },
        create() {
            this.disabled = true
            this.$services.PromoCode().save().then(resp => {
                this.fetch()
            }).finally(() => {
                this.disabled = false
            })
        },
        edit(data) {
            let name = prompt("Change name", data.name)
            if (name) {
                this.$services.PromoCode().update({id: data.id, name}).then(resp => {
                    this.fetch()
                })
            }
        },
        remove(data) {
            if (!confirm("Are you sure?")) return
            this.$services.PromoCode().delete({id: data.id}).then(resp => {
                this.fetch()
            })
        },
        onPageChange(params) {
            this.fetch({ page: params.currentPage });
        },
        copyLink(link) {
            this.$methods.copyToClipboard(link);
            this.$notify.success({ title: 'Copied', message: 'Invite link copied' });
        }
    },
    created() {
        this.fetch()
    }
}
</script>
